import React, { useState } from 'react'
import { FaCircleCheck } from "react-icons/fa6";
import { useDispatch, useSelector } from 'react-redux';
import { addToFullDataSet, getTransactionDetails } from '../../redux/Slices/datasetSlice';
import { makeApiRequest } from '../common/API_request';

import { useNavigate } from 'react-router-dom';

function PaymentSuccess({apikey, closePopUp}) {

    const data = useSelector(getTransactionDetails)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [processing, setProcessing] = useState(false)


    async function openData(key, access_id){
        setProcessing(true)
        const url = `${process.env.REACT_APP_SERVER_URL}/api/marketplace/full-dataset/purchased/${access_id}/`
        const headers = {
            "x-api-key": `${key}`
        }

        const response = await makeApiRequest(url,"GET",headers)
        
        if(response?.full_data.length > 0){
            dispatch(addToFullDataSet(response))
            setProcessing(false)
            navigate(`/profile/market-place/dataset/${access_id}`)
        }
        setProcessing(false)
        return response
    }


  return (
    <div className='bg-[#F3EDED] text-black w-full h-[90vh] 
    flex flex-col justify-center items-center md:h-[80%] rounded-lg py-7 px-4 md:px-12'>
      
    <div className='space-y-4 text-center w-4/5'>
     <h3 className='text-3xl font-semibold'>Payment Success</h3>

        <FaCircleCheck className='text-green-400 text-5xl mx-auto' />
      <p className='font-light text-md'>
      Your payment has been received! To view your purchases, head to your profile or 👇</p>
    </div>

    <div className='flex flex-col justify-center items-center mt-10'>
      <button 
      onClick={() => {
        openData(apikey, data?.dataset_access_id)
      }}
      className='bg-greenCustom text-white font-semibold py-3 px-5 w-[200px] rounded-xl my-2
      transition-all ease-linear delay-300 transform hover:translate-x-4'>
      
        {processing ?
            <div
            className="animate-spin rounded-full h-6 w-6 py-2 mx-auto
            border-t-4 border-white"
            />
            :
            `View purchased data`
            }
      </button>

      <button 
      onClick={closePopUp}
      className='bg-greenCustom text-white font-semibold py-3 px-5 w-[200px] rounded-xl my-4
      transition-all ease-linear delay-300 transform hover:translate-x-4'>
      Search More Data</button>
    </div>
    </div>
  )
}

export default PaymentSuccess
